<style>
.layout.row {
  margin-bottom: 20px !important;
}

.v-select__selections .v-chip__content {
  background: #00ff0a1c;
  color: #19881d;
  border: 1px solid #4caf5061;
  border-radius: 4px !important;
}

.v-select__selections {
  padding-top: .5em;
  padding-bottom: .5em;
}

.v-list-wrapper {
  background: #badf8421;
  padding-right: 1em;
  padding-bottom: 1em;
  border-radius: 6px;
  border: 1px solid #5c88211c;
  padding-top: .5em;
}

.maxwmd {
  max-width: 400px;
}

.maxwlg {
  max-width: 900px;
}

.v-list-wrapper .v-chip.v-chip--disabled.v-chip--label.theme--light {
  background: #e5efd8;
  margin: 0px;
}

.v-chip.v-chip--select-multi {
  border-radius: 4px !important;
}
</style>
<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Обьекты</h3>
          <v-btn color="pink" dark small fab @click="editOpen()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" v-on:keyup="appendQueryToUrl" loading="search"
                placeholder="Поиск" v-model="search" hide-details class="hidden-sm-and-down"></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table :headers="complex.headers" :search="search" :items="objectData"
                :rows-per-page-items="[10, 25, 50, 100]" class="elevation-1" item-key="name"
                no-results-text="Нет результатов" rows-per-page-text="На странице" v-model="complex.selected">
                <template slot="items" slot-scope="props">

                  <td>{{ props.item.objectId }}</td>
                  <td>{{ props.item.objectKey }}</td>
                  <td>{{ props.item.objectTitle }}</td>
                  <td>

                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>

                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog max-width="950px" v-model="popupEdit.isOpen" persistent
                  :class="`${modalData.objectData != null ? 'maxwlg' : 'maxwmd'}`">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID обьекта</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID обьекта" v-model="modalData.objectId" readonly></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Внешний ключ для обьекта</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <span v-if="readonlyFields">{{ modalData.objectKey }}</span>
                            <v-text-field v-if="!readonlyFields" label="Внешний ключ для обьекта"
                              v-model="modalData.objectKey" :rules="rules.objectkey" required></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Наименование обьекта</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Наименование обьекта" v-model="modalData.objectTitle"
                              :rules="rules.required" required></v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- reports composite object -->
                        <v-layout row class="v-list-wrapper"
                          v-if="modalData.objectKey == 'RPT_R' || modalData.objectData != null">
                          <v-flex xs4>
                            <v-subheader>Белый список</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-combobox color="green" clearable chips variant="solo" label="Разрешенные отчеты"
                              :items="reportList" v-model="modalData.objectData" v-model.selected="selectedReportsList"
                              multiple no-data-text="Все отчеты разрешены для просмотра">
                            </v-combobox>
                            <v-chip x-small label closable disabled>Если пусто - применяются стандартные правила.</v-chip>
                          </v-flex>
                        </v-layout>
                        <!-- end reports composite object -->
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Удаление -->

              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить обьект?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors';
import Util from '@/util';

export default {
  components: {
  },
  data() {
    return {
      //selectedReports: [],
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      openColorBox: false,
      colors,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        objectkey: [
          v => !!v || 'Ключ не может быть пустым',
          v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
          v => this.objectData.filter(el => el.objectKey === v).length === 0 || 'Такой ключ уже существует',
        ],
      },
      search: this.$route.query.search != null ? this.$route.query.search : '',
      popupRemove: {
        isOpen: false
      },
      popupEdit: {
        isOpen: false,
        isEditing: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: 'ID обьекта',
            value: 'objectId'
          },
          {
            text: 'Внешний ключ',
            value: 'objectKey'
          },
          {
            text: 'Наименование обьекта',
            value: 'objectTitle'
          },
          {
            text: 'Действия',
            value: ''
          }
        ],
      }
    };
  },

  mounted: function () {

    this.refresh();

    /**
     * Загружаем данные по обьектам при первой отрисовке страницы, если objectData не пустой, то не обновляемся
     */
    if (this.objectData.length === 0) {
      this.refresh();
    }

    /**
     * Загружаем данные о сотрудниках и отчётах
     */
    if (this.reportList.length === 0 || this.accountList.length === 0 || this.staffList.length === 0 || this.staffListForSelect.length === 0) {
      this.refresh();
    }
  },

  computed: {
    accountList() {
      return this.$store.getters["account/accountData"];
    },

    selectedReportsList: {
      get: function () {
        return this.modalData.objectData != null && this.modalData.objectData != '' ? JSON.parse(this.modalData.objectData) : null;
      },
      set: function (data) {
        let parsedData = JSON.stringify(data.map(x => ({
          text: x.text.replace('#', '').replace('&', ''),
          value: x.value
        })));

        this.modalData.objectData = parsedData;

        console.debug('objectData: ', 
        data, 
        parsedData);
        //this.modalData.objectData = data;
      }
    },

    reportList() {
      return this.$store.getters["report/reportData"]
        .map(x => ({
          text: x.nameReport,
          value: x.id,
          //url: x.urlReport,
          //defaultParams: x.defaultParams
        }));
    },

    /**
     * Данные по обьектам
     * @returns {default.computed.objectData|(function())|Array|getters.objectData}
     */
    objectData() {
      return this.$store.getters['object/objectData']
    },

    /**
     * Цвета для выбора в модальном окне
     * @returns (colors)
     */
    computedColors() {
      const colors = {};
      const search = this.search.toLowerCase();

      Object.keys(this.colors).forEach(key => {
        const kebabKey = Util.kebab(key).toLowerCase();

        if (kebabKey.indexOf(search) > -1) {
          colors[kebabKey] = this.colors[key];
        }
      });
      return colors;
    }

  },

  methods: {

    /**
     * Обновление данных по обьектам
     */
    refresh() {
      this.$store._actions['object/getObjectData'][0]();
      this.$store._actions["report/getReportData"][0]();
    },

    appendQueryToUrl() {
      this.$router.push({ query: { search: this.search } })
    },

    /**
     * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
     * @param item
     */
    editOpen(item) {
      // Если редактирование
      if (item !== null && typeof (item) !== 'undefined') {
        //console.debug('Item Data (if present): ', JSON.parse(item.objectData));
        //this.modalData.objectData = JSON.parse(item.objectData);
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.objectData.indexOf(item);
        this.readonlyFields = true;
        // Если добавление
      } else {
        this.modalData = {
          objectId: -1,
          objectKey: '',
          objectTitle: '',
          objectData: null,
        };
        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }
      this.popupEdit.isOpen = true;
    },

    /**
     * Отмена редактирования
     */
    editCancel() {
      if (this.editedIndex != -1) {
        Object.assign(this.objectData[this.editedIndex], this.oldModalData);
      }
      this.popupEdit.isOpen = false;
    },

    /**
     * Сохранение отредактированного элемента
     */
    submit() {
      if (this.$refs.form.validate()) {
        this.$store._actions['object/saveObjectData'][0]({ index: this.editedIndex, data: this.modalData }).then(() => {
          this.popupEdit.isOpen = false;
        })
      }
    },

    /**
     * Открытие модального окна с подтверждением удаления
     * @param data
     */
    removeItemConfirm(data) {
      this.popupRemove.isOpen = true;
      this.modalData = data;
    },

    /**
     * Удаление элемента
     * @param item
     */
    actionRemove(item) {
      this.$store._actions['object/removeObjectData'][0]({ item: item });
      this.popupRemove.isOpen = false;
    },

    /**
     * Изменение цвета по клику
     * @param color
     */
    changeObjectColor(color) {
      this.modalData.objectColor = color;
      this.openColorBox = false;
    },

    /**
     * Вывод последнего элемента
     * @param str
     * @returns {*}
     */
    endStr(str) {
      return str[str.length - 1];
    },

    /**
     * Конвертирование в строки в класс
     * @param str
     * @returns {*}
     */
    convertToClass(str) {
      const end = this.endStr(str);
      const sub = str.substr(0, str.length - 1);

      if (isNaN(parseInt(end, 10))) return str;

      return `${sub}-${end}`;
    },

    /**
     * Получение цвета по ключу
     * @param key
     * @returns {string}
     */
    getColorClass(key) {
      if (['white', 'transparent'].includes(key) ||
        key.indexOf('light') > -1 ||
        key.indexOf('accent') > -1
      ) return 'black--text';

      return 'white--text';
    }
  }
};
</script>

<style>
.v-chip__content {
  cursor: pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/ui/Objects.vue